// Backend clamps getCmpInvoiceCreateLookups to 1000; request that ceiling so
// large chambers do not lose eligible members from invoice member selectors.
export const CMP_INVOICE_CREATE_LOOKUP_LIMIT = 1000;

// Pages that show only the member options skip the event and custom invoice
// reads (Thunder Bay: 13 registration pages and 41 invoice pages per search).
export const MEMBER_ONLY_INVOICE_LOOKUP_PARTS = {
  includeEventOptions: false,
  includeCustomLineItemSuggestions: false,
};
